module.exports = __webpack_public_path__ + "media/promo/courses/images/footer-2-c97ef28beb81f617befeca91984e9366.png";